import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { ConversationIcon } from '@treams/treams-icons';
import { Heading, Label } from '@treams/treams-ui';

export const SelectConversationTypeCardNoSelection = () => {
	const { t } = useTranslation('', {
		keyPrefix: 'evaluations.create.modal.form.selectConversationType.modal',
	});

	return (
		<StyledBox
			display="flex"
			flexGrow={1}
			backgroundColor="whitesmoke"
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
		>
			<Flex width={75} height={75}>
				<ConversationIcon />
			</Flex>
			<Heading>{t('noSelection.title')}</Heading>
			<Label>{t('noSelection.description')}</Label>
		</StyledBox>
	);
};

const StyledBox = styled(Box)`
	background-color: ${({ theme }) => theme.colors.whiteBlue};
`;
